export enum ROOT {
  SETS = 'ROOT_SETS',

  INITIALIZE_SETS = 'ROOT_INITIALIZE_SETS',
}

export enum DECKLIST {
  TITLE = 'DECKLIST_TITLE',
  ADD_CARD = 'DECKLIST_ADD_CARD',
  REMOVE_CARD = 'DECKLIST_REMOVE_CARD',
  EMPTY = 'DECKLIST_EMPTY',

  SAVE = 'DECKLIST_SAVE',
  LOAD = 'DECKLIST_LOAD',
  DELETE = 'DECKLIST_DELETE',
  LOAD_FROM_STRING = 'DECKLIST_LOAD_FROM_STRING',
}

export enum SEARCH {
  LOAD = 'SEARCH_LOAD',
  SUCCESS = 'SEARCH_SUCCESS',
  FAILURE = 'SEARCH_FAILURE',
  NAME = 'SEARCH_NAME',
  TEXT = 'SEARCH_TEXT',
  SETS = 'SEARCH_SETS',
  TYPES = 'SEARCH_TYPES',
  SUBTYPES = 'SEARCH_SUBTYPES',
  SUPERTYPES = 'SEARCH_SUPERTYPES',
  SORT = 'SEARCH_SORT',

  REQUEST = 'SEARCH_REQUEST',
}

export enum MODAL {
  CLEAR = 'MODAL_CLEAR',
  LOAD_DECKLIST = 'MODAL_LOAD_DECKLIST',
  IMPORT_DECKLIST = 'MODAL_IMPORT_DECKLIST',
  SET_CLOSE_INFO_NORMAL = 'MODAL_SET_CLOSE_INFO_NORMAL',
  SET_CARD_INFO = 'MODAL_SET_CARD_INFO',
  SET_CARD_PRICE = 'MODAL_SET_CARD_PRICE',
  SHOW_CARD_INFO = 'MODAL_SHOW_CARD_INFO',
  LOAD_CARD_INFO = 'MODAL_LOAD_CARD_INFO',
  LOAD_CARD_PRICE = 'MODAL_LOAD_CARD_PRICE',
}
